import React from 'react';
import './Table.css';

export interface TableColumn<T = any> {
  key: string;
  header: string;
  width?: string;
  align?: 'left' | 'center' | 'right';
  render?: (value: any, row: T, index: number) => React.ReactNode;
  sortable?: boolean;
}

export interface TableProps<T = any> {
  columns: TableColumn<T>[];
  data: T[];
  loading?: boolean;
  emptyMessage?: string;
  striped?: boolean;
  hoverable?: boolean;
  compact?: boolean;
  className?: string;
  onRowClick?: (row: T, index: number) => void;
  rowKey?: string;
}

export function Table<T extends Record<string, any>>({
  columns, data, loading = false, emptyMessage = 'No records found',
  striped = true, hoverable = true, compact = false,
  className = '', onRowClick, rowKey = 'id',
}: TableProps<T>) {
  return (
    <div className={`ui-table-wrapper ${className}`}>
      <table className={`ui-table ${striped ? 'ui-table-striped' : ''} ${hoverable ? 'ui-table-hover' : ''} ${compact ? 'ui-table-compact' : ''}`}>
        <thead>
          <tr>
            {columns.map(col => (
              <th key={col.key} style={{ width: col.width, textAlign: col.align || 'left' }}>{col.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr><td colSpan={columns.length} className="ui-table-loading">Loading...</td></tr>
          ) : data.length === 0 ? (
            <tr><td colSpan={columns.length} className="ui-table-empty">{emptyMessage}</td></tr>
          ) : (
            data.map((row, idx) => (
              <tr key={row[rowKey] ?? idx} onClick={onRowClick ? () => onRowClick(row, idx) : undefined}
                  className={onRowClick ? 'ui-table-clickable' : ''}>
                {columns.map(col => (
                  <td key={col.key} style={{ textAlign: col.align || 'left' }}>
                    {col.render ? col.render(row[col.key], row, idx) : row[col.key]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
